/** Đăng nhập web riêng qua 7w_portal: authorization code + PKCE (docs/07-portal-integration.md §2.2). */
import { PORTAL_CLIENT_ID, PORTAL_PROTOCOL, PORTAL_URL } from './client';

const KEY = 'swchat:pkce';
const b64url = (b: ArrayBuffer | Uint8Array) =>
  btoa(String.fromCharCode(...new Uint8Array(b))).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');

/** Đường dẫn callback phải khớp redirect_uri đã đăng ký ở IdP (sid đăng ký `/callback`); mặc định `/auth/callback`. */
export const CALLBACK_PATH = import.meta.env.VITE_PORTAL_CALLBACK_PATH || '/auth/callback';
export const redirectUri = () => `${window.location.origin}${CALLBACK_PATH}`;

export async function startPortalLogin() {
  const verifier = b64url(crypto.getRandomValues(new Uint8Array(32)));
  const state = b64url(crypto.getRandomValues(new Uint8Array(16)));
  const challenge = b64url(await crypto.subtle.digest('SHA-256', new TextEncoder().encode(verifier)));
  sessionStorage.setItem(KEY, JSON.stringify({ verifier, state }));

  const oidc = PORTAL_PROTOCOL === 'oidc';
  const url = new URL(oidc ? '/authorize' : '/sso/authorize', PORTAL_URL);
  if (oidc) {
    url.searchParams.set('response_type', 'code');
    url.searchParams.set('scope', 'openid profile email roles');
  }
  url.searchParams.set('client_id', PORTAL_CLIENT_ID);
  url.searchParams.set('redirect_uri', redirectUri());
  url.searchParams.set('code_challenge', challenge);
  url.searchParams.set('code_challenge_method', 'S256');
  url.searchParams.set('state', state);
  window.location.assign(url);
}

/** Đọc `code` từ URL callback và kiểm tra `state`. Trả undefined nếu không hợp lệ. */
export function takeCallback(): { code: string; verifier: string } | undefined {
  const params = new URLSearchParams(window.location.search);
  const saved = sessionStorage.getItem(KEY);
  sessionStorage.removeItem(KEY);
  window.history.replaceState(null, '', '/');
  if (!saved) return undefined;
  const { verifier, state } = JSON.parse(saved) as { verifier: string; state: string };
  const code = params.get('code');
  if (!code || params.get('state') !== state) return undefined;
  return { code, verifier };
}
